"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
let loadStart = false;
function getGoogleAds(setter) {
    if (loadStart)
        return;
    if (document.head.querySelector("#GoogleAds"))
        return;
    loadStart = true;
    const $GoogleAds = document.createElement("script");
    $GoogleAds.id = "GoogleADS";
    // $GoogleAds.async = true;
    $GoogleAds.type = "text/javascript";
    $GoogleAds.crossOrigin = "anonymous";
    $GoogleAds.src =
        "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1272248965614830";
    document.head.appendChild($GoogleAds);
    const set = () => {
        setter(true);
        if (!$GoogleAds)
            return;
        $GoogleAds.removeEventListener("load", set);
    };
    if ($GoogleAds) {
        $GoogleAds.addEventListener("load", set);
    }
}
exports.default = getGoogleAds;
